module.exports = __webpack_public_path__ + "static/paygate-card-brand-logos-86a5923a2d2f14642f3d64b884b8de22.png";